import { render, staticRenderFns } from "./WorkTemplate.vue?vue&type=template&id=4beb286d&scoped=true"
import script from "./WorkTemplate.vue?vue&type=script&lang=js"
export * from "./WorkTemplate.vue?vue&type=script&lang=js"
import style0 from "./WorkTemplate.vue?vue&type=style&index=0&id=4beb286d&prod&scoped=true&lang=less"
import style1 from "./WorkTemplate.vue?vue&type=style&index=1&id=4beb286d&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beb286d",
  null
  
)

export default component.exports